import styled from "styled-components/macro"

export const FooterWrap = styled.div`
  padding: 20px;
  background-color: #272f34;
`
